import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ngx-form-check',
  templateUrl: './form-check.component.html',
  styleUrls: ['./form-check.component.scss'],
})
export class FormCheckComponent implements OnInit {
  @Input() name: string;
  @Input() title: string;
  @Input() value: boolean;
  @Input() disabled: boolean = false;
  @Output() valueChange: EventEmitter<boolean>;

  constructor() {
    this.valueChange = new EventEmitter<boolean>();
  }

  ngOnInit() {
  }

  updateValue(value: boolean) {
    this.valueChange.emit(value );
  }
}
